<div class="flex flex-col justify-center items-start profile-item">
    <div class="flex flex-row justify-start items-center line-item">
        <div class="line-label">User suspended:</div>
        <div *ngIf="isSuspended" class="line-value red">Yes</div>
        <button
            *ngIf="isSuspended"
            class="fm-btn fm-btn--brand-1 fm-btn--xs"
            style="min-width: 100px"
            (click)="onRestore.emit()"
            >Restore</button
        >
        <div *ngIf="!isSuspended" class="line-value green">No</div>
        <button
            *ngIf="!isSuspended"
            class="fm-btn fm-btn--brand-1 fm-btn--xs"
            style="min-width: 100px"
            (click)="onSuspend.emit()"
            >Suspend</button
        >
    </div>

    <div class="flex flex-row justify-start items-center line-item">
        <div class="line-label">User verified:</div>
        <div *ngIf="isVerified" class="line-value green">Yes</div>
        <div *ngIf="!isVerified" class="line-value red">No</div>
        <button
            class="fm-btn fm-btn--brand-1 fm-btn--xs"
            style="min-width: 100px"
            (click)="onVerifyUser.emit(!isVerified)"
            >{{ isVerified ? 'Unverify' : 'Verify' }}</button
        >
    </div>

    <div class="flex flex-row justify-start items-center line-item">
        <div class="line-label">{{ planAccess }}</div>
        <div *ngIf="isCanceled" class="line-value red">Canceled</div>
        <div *ngIf="!isCanceled && canCancel" class="line-value green">Active</div>
        <div *ngIf="!isCanceled && !canCancel" class="line-value">Free</div>
        <button
            [disabled]="!canCancel"
            class="fm-btn fm-btn--brand-1 fm-btn--xs"
            style="min-width: 100px"
            (click)="onCancelSub.emit()"
            >Cancel subscription</button
        >
    </div>

    <div class="flex flex-col justify-start items-start line-item">
        <div class="line-label">Change Email:</div>
        <div class="f-form-field w-full field-spacer fm-mt-10px" style="flex-direction: row">
            <input
                style="max-width: 162px; min-height: 30px"
                class="w-full"
                maxlength="100"
                type="email"
                [(ngModel)]="newEmailAddress"
                name="email"
                required
                appFmAutofocus />
            <button
                class="fm-btn fm-btn--brand-1 fm-btn--xs"
                style="min-width: 100px; margin-left: 37px"
                (click)="confirmUpdateEmailAddress()"
                >Change email address</button
            >
        </div>
    </div>
</div>
